export default "__VITE_ASSET__CcO$w04a__"